import { render, staticRenderFns } from "./msgEdit.vue?vue&type=template&id=1657201c&scoped=true"
import script from "./msgEdit.vue?vue&type=script&lang=js"
export * from "./msgEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1657201c",
  null
  
)

export default component.exports